import { reportFetchError } from './vue-helpers';

class FetchWrapper {
  // constructor(headers = {'Content-Type': 'application/json'} ) {
  //   this.headers = { headers} ;
  // }
  constructor() {
    this.headers = { 'Content-Type': 'application/json' };
  }

  async getProductSectionContent(sectionId, blockId, productHandle, callback) {
    const baseUrl = `${window.theme.routes.root_url}products/${productHandle}?section_id=${sectionId}`;
    const url = blockId ? `${baseUrl}&block_id=${blockId}` : baseUrl;
    fetch(url)
      .then(response => response.body)
      .then(rb => {
        const reader = rb.getReader();
        return new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                push();
              });
            }
            push();
          }
        });
      })
      .then(stream => new Response(stream, { headers: { 'Content-Type': 'text/html' } }).text())
      .then(result => {
        const returnData = {
          result: result,
          handle: productHandle,
          sectionId: sectionId,
          ...(blockId && { blockId })
        };
        callback(returnData);
      });
  }

  async getPageContent(sizeGuideMetafield, callback) {
    const url = `${window.theme.routes.root_url}pages/${sizeGuideMetafield}`;
    fetch(url)
      .then(response => response.body)
      .then(rb => {
        const reader = rb.getReader();
        return new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value);
                push();
              });
            }
            push();
          }
        });
      })
      .then(stream => new Response(stream, { headers: { 'Content-Type': 'text/html' } }).text())
      .then(result => {
        const returnData = {
          result: result
        };
        callback(returnData);
      });
  }

  get(url) {
    return (window.theme.fetchWithRetry || window.fetch).call(window, url);
  }

  postCart(data, current, callback, errorCallback) {
    const url = window.Shopify.routes.root + 'cart/add.js';
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };
    (window.theme && window.theme.fetchWithRetry ? window.theme.fetchWithRetry : window.fetch)
      .call(window, url, options)
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.message || `Cart add failed with status ${response.status}`);
          error.status = response.status;
          error.data = errorData;
          throw error;
        }
        return response.json();
      })
      .then(data => {
        data.self = current;
        callback(data);
      })
      .catch(error => {
        reportFetchError('Cart add failed', error, {
          url,
          status: error.status,
          data: error.data
        });
        if (errorCallback) {
          errorCallback(error, current);
        }
      });
  }
}

export default new FetchWrapper();
